import { Component, OnInit } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { EnquiriesService } from './../services/enquiries.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastService } from './../services/toast.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import * as $ from 'jquery';

declare var google: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html'
})
export class ContactUsComponent implements OnInit {
  scrollTimer: any;

  EnquiryData_ContactUs$: FormGroup;
  ResultMessage_ContactUs$: string = "";
  submitted_contactUs: boolean = false;
  pageErrors_ContactUs: boolean = false;
  captchaInvalid_ContactUs: boolean = true;

  EnquiryData_WantToVisitUs$: FormGroup;
  ResultMessage_WantToVisitUs$: string = "";
  submitted_wantToVisitUs: boolean = false;
  pageErrors_WantToVisitUs: boolean = false;
  captchaInvalid_WantToVisitUs: boolean = true;

  EnquiryData_LodgeAComplaint$: FormGroup;
  ResultMessage_LodgeAComplaint$: string = "";
  submitted_lodgeAComplaint: boolean = false;
  pageErrors_LodgeAComplaint: boolean = false;
  captchaInvalid_LodgeAComplaint: boolean = true;

  ContactUsTopics$: any[] = [
    { "id": "2", "title": "General Query" },
    { "id": "5", "title": "Automotive" },
    { "id": "6", "title": "Agro - processing" },
    { "id": "8", "title": "Chemical Manufacturing" },
    { "id": "9", "title": "Energy" },
    { "id": "10", "title": "Metals" },
    { "id": "11", "title": "Marketing and Communication" },
    { "id": "12", "title": "Logistics" },
    { "id": "13", "title": "Business Process outsourcing" },
    { "id": "14", "title": "Human Capital Solution" },
    { "id": "15", "title": "SMME Development Unit" }
  ];

  LodgeAComplaintTopics$: any[] = [
    { "id": "2", "title": "IDZ General" },
    { "id": "5", "title": "Automotive" },
    { "id": "6", "title": "Agro-processing" },
    { "id": "8", "title": "Petrochemical" },
    { "id": "9", "title": "General Manufacturing" },
    { "id": "10", "title": "Business Process Outsourcing and Shoring" },
    { "id": "11", "title": "Energy" },
    { "id": "12", "title": "Port" }
  ];

  constructor(
    private datePipe: DatePipe,
    private enquiriesService: EnquiriesService,
    public toastService: ToastService,
    private formBuilder: FormBuilder) {
  }

  resolvedContactUs(captchaResponse: string) {
    if (captchaResponse === null) {
      this.captchaInvalid_ContactUs = true;
    }
    else {
      this.captchaInvalid_ContactUs = false;
    }
  }

  resolvedWantToVisitUs(captchaResponse: string) {
    if (captchaResponse === null) {
      this.captchaInvalid_WantToVisitUs = true;
    }
    else {
      this.captchaInvalid_WantToVisitUs = false;
    }
  }

  resolvedLodgeAComplaint(captchaResponse: string) {
    if (captchaResponse === null) {
      this.captchaInvalid_LodgeAComplaint = true;
    }
    else {
      this.captchaInvalid_LodgeAComplaint = false;
    }
  }

  get f_contactUs() { return this.EnquiryData_ContactUs$.controls; }
  get f_wantToVisitUs() { return this.EnquiryData_WantToVisitUs$.controls; }
  get f_lodgeAComplaint() { return this.EnquiryData_LodgeAComplaint$.controls; }

  ngOnInit() {

    this.EnquiryData_ContactUs$ = this.formBuilder.group({
      id: [0, Validators.required],
      nameAndSurname: ['', Validators.required],
      telephoneNumber: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")]],
      topic: ['N/A', Validators.required],
      topicId: [2, Validators.required],
      message: ['', Validators.required],
      recaptchaReactive: null
    });

    this.EnquiryData_WantToVisitUs$ = this.formBuilder.group({
      id: [0, Validators.required],
      nameAndSurname: ['', Validators.required],
      company: ['', Validators.required],
      country: ['', Validators.required],
      telephoneNumber: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")]],
      message: ['', Validators.required],
      recaptchaReactive: null
    });

    this.EnquiryData_LodgeAComplaint$ = this.formBuilder.group({
      id: [0, Validators.required],
      nameAndSurname: ['', Validators.required],
      company: ['', Validators.required],
      telephoneNumber: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")]],
      subjectId: [2, Validators.required],
      subject: ['N/A', Validators.required],
      message: ['', Validators.required],
      recaptchaReactive: null
    });

    $(".ctrlLeft").click(function () {
      $(this).closest('div').find('.controls').animate({ scrollLeft: '+=177' }, 300);
    });

    $(".ctrlRight").click(function () {
      $(this).closest('div').find('.controls').animate({ scrollLeft: '-=177' }, 300);
    });

    setTimeout(function () {
      try {

        const peLatLng = { lat: -33.7964569, lng: 25.6657146 };
        const mapPe = new google.maps.Map(document.getElementById('mapPE'), { center: peLatLng, zoom: 16 });
        new google.maps.Marker({ position: peLatLng, map: mapPe, title: 'Coega Port Elizabeth' });

        const ctLatLng = { lat: -33.9287903, lng: 18.4207914 };
        const mapCt = new google.maps.Map(document.getElementById('mapCT'), { center: ctLatLng, zoom: 16 });
        new google.maps.Marker({ position: ctLatLng, map: mapCt, title: 'Coega Cape Town' });

        const elLatLng = { lat: -32.9926968, lng: 27.9097177 };
        const mapEl = new google.maps.Map(document.getElementById('mapEL'), { center: elLatLng, zoom: 16 });
        new google.maps.Marker({ position: elLatLng, map: mapEl, title: 'Coega East London' });

        const nlLatLng = { lat: -29.7225819, lng: 31.070774 };
        const mapNl = new google.maps.Map(document.getElementById('mapNL'), { center: nlLatLng, zoom: 16 });
        new google.maps.Marker({ position: nlLatLng, map: mapNl, title: 'Coega Durban' });

        const pTLatLng = { lat: -25.7574288, lng: 28.2251566 };
        const mapPT = new google.maps.Map(document.getElementById('mapPT'), { center: pTLatLng, zoom: 16 });
        new google.maps.Marker({ position: pTLatLng, map: mapPT, title: 'Coega Pretoria' });

        const mTLatLng = { lat: -31.588617, lng: 28.7730118 };
        const mapmT = new google.maps.Map(document.getElementById('mapmT'), { center: mTLatLng, zoom: 16 });
        new google.maps.Marker({ position: mTLatLng, map: mapmT, title: 'Coega Mthatha' });
  

      } catch (e) {
        console.log(e.message);
      }
    }, 1000);

  }

  sendWantToVisitUsEnquiry() {

    this.ResultMessage_WantToVisitUs$ = "Submitting, please wait...";

    this.submitted_wantToVisitUs = true;
    this.pageErrors_WantToVisitUs = false;

    if (this.EnquiryData_WantToVisitUs$.invalid) {
      this.pageErrors_WantToVisitUs = true;
      this.ResultMessage_WantToVisitUs$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid_WantToVisitUs === true) {
      this.pageErrors_WantToVisitUs = true;
      this.ResultMessage_WantToVisitUs$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 3,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    enquiry.EnquiryProperties.push({ "key": "nameAndSurname", "value": this.EnquiryData_WantToVisitUs$.controls.nameAndSurname.value });
    enquiry.EnquiryProperties.push({ "key": "company", "value": this.EnquiryData_WantToVisitUs$.controls.company.value });
    enquiry.EnquiryProperties.push({ "key": "country", "value": this.EnquiryData_WantToVisitUs$.controls.country.value });
    enquiry.EnquiryProperties.push({ "key": "telephoneNumber", "value": this.EnquiryData_WantToVisitUs$.controls.telephoneNumber.value });
    enquiry.EnquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData_WantToVisitUs$.controls.emailAddress.value });
    enquiry.EnquiryProperties.push({ "key": "message", "value": this.EnquiryData_WantToVisitUs$.controls.message.value });
    enquiry.EnquiryProperties.push({ "key": "subject", "value": "Want To Visit Us" });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
      this.ResultMessage_WantToVisitUs$ = "Your message has been sent!";
      this.toastService.show('WANT TO VISIT US - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
      this.EnquiryData_WantToVisitUs$.reset();


      Object.keys(this.EnquiryData_WantToVisitUs$.controls).forEach(key => {
        this.EnquiryData_WantToVisitUs$.get(key).setErrors(null);
      });
      this.EnquiryData_WantToVisitUs$.controls.recaptchaReactive = null;
    }, (error) => {
        this.ResultMessage_WantToVisitUs$ = "An error occurred. Please try again later.";
        this.toastService.show('WANT TO VISIT US - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })
  }

  sendLodgeAComplaintEnquiry() {

    this.ResultMessage_LodgeAComplaint$ = "Submitting, please wait...";

    this.submitted_lodgeAComplaint = true;
    this.pageErrors_LodgeAComplaint = false;

    if (this.EnquiryData_LodgeAComplaint$.invalid) {
      this.pageErrors_LodgeAComplaint = true;
      this.ResultMessage_LodgeAComplaint$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid_LodgeAComplaint == true) {
      this.pageErrors_LodgeAComplaint = true;
      this.ResultMessage_LodgeAComplaint$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 4,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    enquiry.EnquiryProperties.push({ "key": "nameAndSurname", "value": this.EnquiryData_LodgeAComplaint$.controls.nameAndSurname.value });
    enquiry.EnquiryProperties.push({ "key": "company", "value": this.EnquiryData_LodgeAComplaint$.controls.company.value });
    enquiry.EnquiryProperties.push({ "key": "telephoneNumber", "value": this.EnquiryData_LodgeAComplaint$.controls.telephoneNumber.value });
    enquiry.EnquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData_LodgeAComplaint$.controls.emailAddress.value });
    enquiry.EnquiryProperties.push({ "key": "subjectId", "value": this.EnquiryData_LodgeAComplaint$.controls.subjectId.value.toString() });
    let title;
    try {
      title = this.ContactUsTopics$.find(x => x.id === this.EnquiryData_LodgeAComplaint$.controls.topicId.value).title
    } catch (e) {
      title = "IDZ General"
    }
    enquiry.EnquiryProperties.push({ "key": "subject", "value": title });
    enquiry.EnquiryProperties.push({ "key": "message", "value": this.EnquiryData_LodgeAComplaint$.controls.message.value });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
      this.ResultMessage_LodgeAComplaint$ = "Your message has been sent!";
      this.toastService.show('LODGE A COMPLAINT - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
      this.EnquiryData_LodgeAComplaint$.reset();
      

      Object.keys(this.EnquiryData_LodgeAComplaint$.controls).forEach(key => {
        this.EnquiryData_LodgeAComplaint$.get(key).setErrors(null);
      });
      this.EnquiryData_LodgeAComplaint$.controls.recaptchaReactive = null;
    }, (error) => {
        this.ResultMessage_LodgeAComplaint$ = "An error occurred. Please try again later.";
        this.toastService.show('LODGE A COMPLAINT - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })
  }

  sendContactUsEnquiry() {

    this.ResultMessage_ContactUs$ = "Submitting, please wait...";

    this.submitted_contactUs = true;
    this.pageErrors_ContactUs = false;

    if (this.EnquiryData_ContactUs$.invalid) {
      this.pageErrors_ContactUs = true;
      this.ResultMessage_ContactUs$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid_ContactUs === true) {
      this.pageErrors_ContactUs = true;
      this.ResultMessage_ContactUs$ = "Please complete the captcha";
      return;
    }    

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 2,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    enquiry.EnquiryProperties.push({ "key": "nameAndSurname", "value": this.EnquiryData_ContactUs$.controls.nameAndSurname.value });
    enquiry.EnquiryProperties.push({ "key": "telephoneNumber", "value": this.EnquiryData_ContactUs$.controls.telephoneNumber.value });
    enquiry.EnquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData_ContactUs$.controls.emailAddress.value });
    enquiry.EnquiryProperties.push({ "key": "topicId", "value": this.EnquiryData_ContactUs$.controls.topicId.value.toString() });
    let title;
    try {
      title = this.ContactUsTopics$.find(x => x.id === this.EnquiryData_ContactUs$.controls.topicId.value).title
    } catch (e) {
      title = "General Query"
    }
    enquiry.EnquiryProperties.push({ "key": "topic", "value": title });
    enquiry.EnquiryProperties.push({ "key": "message", "value": this.EnquiryData_ContactUs$.controls.message.value });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {      
      try {
        this.ResultMessage_ContactUs$ = "Your message was successfully sent";
        this.toastService.show('CONTACT US - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
        this.EnquiryData_ContactUs$.reset();
        this.pageErrors_ContactUs = false;

        Object.keys(this.EnquiryData_ContactUs$.controls).forEach(key => {
          this.EnquiryData_ContactUs$.get(key).setErrors(null);
        });
        this.EnquiryData_ContactUs$.controls.recaptchaReactive = null;
      } catch (e) {
        console.log(e.message);

      }
      
      
    }, (error) => {
        this.ResultMessage_ContactUs$ = "An error occurred. Please try again later.";
        this.toastService.show('CONTACT US - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })
  }

}
